/* eslint-disable import/no-unresolved */
/* eslint-disable import/prefer-default-export */
import {
  UnusedRequestType,
  UnusedIdentityType
} from '@src/endpoints/services/graphQueryMgr.service'

export enum GridTabs {
  UnusedRoles = UnusedRequestType.UNUSED_SUMMARY,
  UnusedServices = UnusedRequestType.UNUSED_BY_SERVICE_SUMMARY,
  UnusedPermissions = UnusedRequestType.UNUSED_BY_PRIVILEGE_SUMMARY
}

export interface Params {
  identity_type?: UnusedIdentityType
  summary_request_type?: UnusedRequestType
  request_type?: UnusedRequestType
  identity_uri?: string
  role_uri?: string
  role_name?: string
  identity_name?: string
}

export interface PluginOptions {
  dispatch?: any
  currentAccountId?: string
  request_type?: UnusedRequestType
  identity_type?: UnusedIdentityType
  selectedItems?: string[]
  postAction?: () => void
  useReportService?: boolean
}
